// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "small[data-v-51c8cb42]{font-size:.7rem}.custom-nav[data-v-51c8cb42]{background-color:#eee;overflow:hidden}.custom-nav-item[data-v-51c8cb42]{color:#979797}.custom-nav-item.selected[data-v-51c8cb42]{color:#c200fb}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
